<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/dashboard/dashboard.title')"
                  :subtitle="Lang.get('employerdashboard::pages/dashboard/dashboard.intro')">
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="news">
            <div class="card h-100 border-radius-8 border-0 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{ Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.title') }}</h4>
                    <div class="card-text color-dark-blue" v-if="$page.props.isDemoMode">
                        <span class="font-aileron-bold">
                            {{
                                Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.demo_item.title')
                            }}
                        </span>
                        <br/>
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.demo_item.description')
                        }}
                    </div>
                    <div class="card-text color-dark-blue" v-else>
                        <span class="font-aileron-bold">
                            {{
                                Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.item.title')
                            }}
                        </span>
                        <br/>
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.item.description')
                        }}
                    </div>
                </div>
                <div class="card-footer border-0 bg-white mb-1">
                    <a :href="route('nl.employerdashboard.news.overview', $page.props.auth.user.selected_company.uuid)"
                       class="font-poppins font-weight-light color-dark-blue">
                        <u>{{
                                Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.news.see_more')
                            }}</u>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="card h-100 border-radius-8 border-0 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.employees.title')
                        }}</h4>
                    <div class="card-text color-dark-blue">
                        <div class="font-poppins font-weight-light font-size-56 color-orange">
                            {{ total_employees }}
                        </div>
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.employees.description')
                        }}
                    </div>
                </div>
                <div class="card-footer border-0 bg-white mb-1">
                    <inertia-link class="font-poppins font-weight-light color-dark-blue"
                                  :href="route('nl.employerdashboard.employees.overview', this.$page.props.auth.user.selected_company.uuid)">
                        <u>{{
                                Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.employees.see_more')
                            }}</u>
                    </inertia-link>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="notification && notifications_count === 1">
            <div class="card h-100 border-radius-8 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">{{
                            notification.title
                        }}</h4>
                    <div class="card-text color-dark-blue">
                        {{ notification.content }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="notification && notifications_count > 1">
            <div class="card h-100 border-radius-8 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.notifications.title')
                        }}</h4>
                    <div class="card-text color-dark-blue">
                        <div class="font-poppins font-weight-light font-size-56 color-orange">
                            {{ notifications_count }}
                        </div>
                    </div>
                    <div class="card-footer border-0 bg-white mb-1">
                        <a
                            :href="route('nl.employerdashboard.notifications.overview', this.$page.props.auth.user.selected_company.uuid)"
                            class="font-poppins font-weight-light color-dark-blue">
                            <u>
                                {{
                                    Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.notifications.see_more')
                                }}
                            </u>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="card h-100 border-radius-8 border-0 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.invoices.title')
                        }}</h4>
                    <div class="card-text color-dark-blue">
                        <div class="font-poppins font-weight-light font-size-56 color-orange">{{
                                total_invoices
                            }}
                        </div>
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.invoices.description')
                        }}
                    </div>
                </div>
                <div class="card-footer border-0 bg-white mb-1">
                    <a
                        :href="route('nl.employerdashboard.invoices.overview', this.$page.props.auth.user.selected_company.uuid)"
                        class="font-poppins font-weight-light color-dark-blue">
                        <u>
                            {{ Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.invoices.see_more') }}
                        </u>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="requests.length">
            <div class="card h-100 border-radius-8 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.requests.title')
                        }}</h4>
                    <div class="card-text color-dark-blue">
                        <div class="font-poppins font-weight-light font-size-56 color-orange">1.589</div>
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.requests.description')
                        }}
                    </div>
                </div>
                <div class="card-footer border-0 bg-white mb-1">
                    <a href="#" class="font-poppins font-weight-light color-dark-blue">
                        <u>{{
                                Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.requests.see_more')
                            }}</u>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="$page.props.auth.isCompanyProviderManually">
            <div class="card h-100 border-radius-8 border-0 shadow">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-blue">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.new_employee.title')
                        }}</h4>
                    <div class="card-text color-dark-blue mb-4">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.new_employee.description')
                        }}
                    </div>
                </div>
                <div class="card-footer border-0 bg-white mb-1">
                    <a :href="route('nl.employerdashboard.employees.overview', this.$page.props.auth.user.selected_company.uuid)"
                       class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.new_employee.see_more')
                        }}
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4" v-if="this.$page.props.problems.problem_with_provider">
            <div class="card h-100 border-radius-8 border-0 bg-error-message shadow position-relative"
                 v-for="problem in this.$page.props.problems.problem_with_provider">
                <div class="card-body">
                    <h4 class="card-title font-poppins font-weight-light color-white">{{ problem.title }}</h4>
                    <div class="card-text color-white">{{ problem.description }}</div>
                </div>
                <div class="card-footer border-0 bg-error-message mb-1">
                    <inertia-link
                        class="btn btn-primary font-poppins font-weight-bold btn-white border-radius-19"
                        :href="problem.link">
                        {{
                            Lang.get('employerdashboard::pages/dashboard/dashboard.widgets.provider.error.see_more')
                        }}
                    </inertia-link>
                </div>
                <img src="/img/employer-dashboard/icon-error-message.svg" class="position-absolute error-icon">
            </div>
        </div>
    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper'

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/dashboard/dashboard.meta.title'),
        }
    },

    components: {
        CardWrapper
    },

    props: {
        total_invoices: Number,
        notification: [Object, Array],
        notifications_count: Number,
        requests: Object,
        news: Object,
        error: Object,
        total_employees: Number,
    },
}
</script>
